
import Deshmukh from "./Deshmukh.jpeg"

import Metkar from "./Rmetkar.jpeg"

//notable speakers
const users = [
  {
    
    name: 'Dr.Lalit Kumar (Convener),',
    img : Deshmukh,
    detail : 'IILM University, Greater Noida, UP'
  },
  
  {
    name: ' Dr. Deependra Rastogi (Convener)',
    img:  Metkar,
    detail :'IILM University Greater Noida, UP'
  }]
  export default users